import Utils from './utils';
import * as keys from './keys';
import ProductConstants from 'constants/ProductConstants';



const initialDefaults = (formRef, data) => {
 let productData = data?.data?.BI.find((item) => item.risk === data?.data?.risk);
	let biResponse = productData.parsedResponse;
	let biRequest = productData.bi_request;
	let firstYearResponse = productData.firstYearResponse;
	let LumpsumBenefit = biRequest?.LumpsumBenefit?.toString()
	let frequency = biRequest.INPUT_MODE.toString()
 let incomeBenefitPayOutFrequency = biRequest.IncomeBenefitPayoutFrequency
	let SameProposer = biRequest?.SameProposer
	let annualisedPremium = biRequest.PR_ANNPREM == 0 ? firstYearResponse?.MODAL_PREM: biRequest.PR_ANNPREM;
	let pt = biRequest.PR_PT
	let ppt = biRequest.PR_PPT

 formRef.$('PT').value = { id: pt, label: pt };

	Utils.getPremiumTermList(ppt,formRef)
	Utils.getPolicyTermList(biRequest.LI_ENTRY_AGE, LumpsumBenefit, formRef)

	formRef.$('PPT').value = { id: ppt, label: ppt };


 switch (frequency) {

		case '1':
			formRef.$('payment-frequency').set('value', { label: 'Annual', id: '1' })
			break;
		case '2':
			formRef.$('payment-frequency').set('value', { label: 'Semi-Annual', id: '2' })
			break;
		case '3':
			formRef.$('payment-frequency').set('value', { label: 'Quarterly', id: '3' })
			break;
		case '4':
			formRef.$('payment-frequency').set('value', { label: 'Monthly', id: '4' })
			break;

		default:
			break;

	}

 switch (incomeBenefitPayOutFrequency) {

		case '1':
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Annual', id: '1' })
			break;
		case '2':
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Semi-Annual', id: '2' })
			break;
		case '3':
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Quarterly', id: '3' })
			break;
		case '4':
			formRef.$('income-benefit-pay-out-frequency').set('value', { label: 'Monthly', id: '4' })
			break;

		default:
			break;

	}


	switch (LumpsumBenefit) {
		case "1":
			formRef.$('lump-sum-benefit').set('value', {label: 'Yes', id: '1'})
			break;

			case "2":
				formRef.$('lump-sum-benefit').set('value', {label: 'No', id: '2'})
				break;
	
		default:
			break;
	}


	formRef.$('annualised-premium').set('value', annualisedPremium)

 // RIDER INITIAL VALUES

 if (biRequest.ADBRider) {
		formRef.$('ADB').set('value', biRequest.ADBRider !== '')
		if (biRequest.ADBRider) {
			formRef.$('ADB-dropdown').set('value', biRequest.ADBRider)
		}
	}
	if (biRequest.ATPDRider) {
		formRef.$('ATPDRider').set('value', biRequest.ATPDRider !== '')
		if (biRequest.ATPDRider) {
			formRef.$('ATPDRider-dropdown').set('value', biRequest.ATPDRider)
		}
	}

	if (biRequest.WaiverOfPremiumRider) {
		formRef.$('WaiverOfPremiumRider').set('value', biRequest.WaiverOfPremiumRider !== '')
	}

	if (biRequest.HospitalityCashBenefitRider) {
		formRef.$('HospitalityCashBenefitRider').set('value', biRequest.HospitalityCashBenefitRider !== '')
		if (biRequest.HospitalityCashBenefitRider) {
			formRef.$('HospitalityCashBenefitRider-dropdown').set('value', biRequest.HospitalityCashBenefitRider)
		}
	}

	if (biRequest.CriticalIllnessRider) {
		formRef.$('CriticalIllnessRider').set('value', biRequest.CriticalIllnessRider !== '')
		if (formRef.$('CriticalIllnessRider').value) {
			formRef.$('CriticalIllnessRider-dropdown').set('value', biRequest.CriticalIllnessRider)
		}
	}
	

				if(SameProposer) formRef.$('PayorWaiverBenefitRider').set('disabled', true)
				else formRef.$('PayorWaiverBenefitRider').set('disabled', false)

	if (biRequest.PayorWaiverBenefitRider) {

		formRef.$('PayorWaiverBenefitRider').set('value', biRequest.PayorWaiverBenefitRider !== '')
		
		if (formRef.$('PayorWaiverBenefitRider').value) {
			switch (biRequest.PWB) {
				case '1':
					formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
						id: '1',
						label: 'Option 1 (On Death)'
					})
					break;
				case '2':
					formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
						id: '2',
						label: 'Option 2 (CI or ATPD)'
					})
					break;
				case '3':
					formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
						id: '3',
						label: 'Option 3 (CI or ATPD or Death)'
					})
					break;
				default:
					break;
			}
		}
	}

}



export default initialDefaults